import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IUser } from '@webapp/users/interfaces/users.interface';

@Component({
  selector: 'app-selected-agent',
  imports: [CommonModule],
  templateUrl: './selected-agent.component.html',
  styleUrl: './selected-agent.component.css',
})
export class SelectedAgentComponent {
  user = input.required<IUser>()
  clearUser = output<void>();
  
  handleClick(){
    this.clearUser.emit();
  }
}
